








































import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import OmnisearchResultSet from '@/modules/omnisearch/store/OmnisearchResultSet'
import * as api from '@/modules/omnisearch/api'
import ReservationsResultList from '@/modules/omnisearch/components/ReservationsResultList.vue'
import PostsResultList from '@/modules/omnisearch/components/PostsResultList.vue'
import OmnisearchResultItem from '@/modules/omnisearch/store/OmnisearchResultItem';
import AppMenusResultList from '@/modules/omnisearch/components/AppMenusResultList.vue';
import {MenuItem} from '@/store/types';
import MediaObjectsResultList from '@/modules/omnisearch/components/MediaObjectsResultList.vue';
import UsersResultList from '@/modules/omnisearch/components/UsersResultList.vue';


@Component({
    components: {
        ReservationsResultList,
        PostsResultList,
        AppMenusResultList,
        MediaObjectsResultList,
        UsersResultList,
    },
})
export default class Omnisearch extends Vue {
    /**
     * Lista de conjuntos de resultados
     *
     * @var { number }
     */
    public results: OmnisearchResultSet[] = []

    /**
     * Indica si la barra de búsqueda se encuentra cargando
     */
    public loading = false

    public menu = false

    public panels: number[] = []

    public appMenus: MenuItem[] = []

    public get hasResults () {
        return !!this.results.length
    }

    public clickInput () {
        this.menu = this.hasResults
    }

    public resultTypes = {
        posts: {component: 'PostsResultList'},
        reservations: {component: 'ReservationsResultList'},
        mediaObjects: {component: 'MediaObjectsResultList'},
        appMenus: {component: 'AppMenusResultList'},
        users: {component: 'UsersResultList'},
    }

    public onSearch = _.debounce(async function (this: Omnisearch, term: string) {
        if (!term || term.length < 3) {
            return
        }

        this.results = []


        const normalizedTerm = term.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
        const menuItems = this.appMenus.filter(item => {
            const normalizedTitle = item.title.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()

            return normalizedTitle.includes(normalizedTerm) && !!item.routeName
        })

        if (menuItems.length) {
            const appMenuResultSet = new OmnisearchResultSet()
            appMenuResultSet.type = 'appMenus'
            appMenuResultSet.totalCount = menuItems.length
            appMenuResultSet.items = menuItems.map(item => {
                return Object.assign(new OmnisearchResultItem(), {
                    id: 0,
                    title: item.title,
                    attributes: {
                        icon: item.icon,
                        routeName: item.routeName,
                    },
                })
            })

            this.results.push(appMenuResultSet)

            this.menu = true
        }

        this.loading = true
        this.results.push(...(await api.search(term)))

        // Abre todos los paneles de expansión
        this.panels = Array.from(Array(this.results.length).keys())

        this.loading = false
        this.menu = true
    }, 500)

    public created () {
        const flatMenu = (menus: MenuItem[]) => {
            const result: MenuItem[] = []
            for (const item of menus) {
                result.push(item)
                if (item.children && item.children.length) {
                    result.push(...flatMenu(item.children))
                }
            }

            return result
        }

        this.appMenus = flatMenu(this.$store.state.menuItems)
    }
}
